<template>
  <div class="main-width">
    <div class="page-title">Assessment Submission & Software Download</div>
    <div-unit
      unitTitle="Measuring and Locating the Changes in Protein Structure"
    >
      <div style="display: flex; flex-direction: column">
        <div>
          <p style="text-align: center; font-weight: bold; font-size: 22px">
            Upload a pair of protein structure files in PDB or PDBx/mmCIF
            format.
          </p>
          <p style="text-align: center; font-size: 18px">
            Please upload a <i>PDB</i> or <i>PDBx/mmCIF</i> format

            <a
              href="/assessment-result?id=1749217504027"
              style="font-style: italic"
              ># Example 1</a
            >;
            <a
              href="/assessment-result?id=1749217603658"
              style="font-style: italic"
              ># Example 2</a
            >;
            <a
              href="/assessment-result?id=1749217696353"
              style="font-style: italic"
              ># Example 3</a
            >;
            <a
              href="/assessment-result?id=1749220258896"
              style="font-style: italic"
              ># Example 4</a
            >
          </p>
        </div>
        <br /><br />

        <div class="upload-container">
          <div style="width: 50%">
            <file-upload
              :upload-url="upload_url"
              @success="uploadSuccess"
              @remove="handleRemove"
              @selected="uploadSelected"
              @described="uploadDescribed"
              :upload-index="1"
              label="Upload protein structure 1 (mandatory)"
            />
          </div>

          <div class="divider"></div>

          <div style="width: 50%">
            <file-upload
              :upload-url="upload_url"
              @success="uploadSuccess"
              @remove="handleRemove"
              @selected="uploadSelected"
              @described="uploadDescribed"
              :upload-index="2"
              label="Upload protein structure 2 (mandatory)"
            />
          </div>
        </div>

        <div
          class="upload-container" style="margin-top: 20px;"
          v-if="upload_str1 && upload_str2"
        >

          <div style="width: 50%">
            <p style="margin: 20px 0">
              <b>Final Step:</b>
               Select alignment method (optional)
            </p>
            <el-select
              v-model="alignment_selected"
              placeholder="please select an alignment method"
              style="width: 500px"
            >
              <el-option
                v-for="(k, v, i) in alignments_options"
                :key="i"
                :label="v"
                :value="k"
              >
              </el-option>
            </el-select>
          </div>
          <div class="divider" style="background: #fff;"></div>
          <div style="width: 50%">
            <p style="margin: 20px 0">
              Input email address (optional):
            </p>

            <el-input
              v-model="email"
              placeholder="email address for notifications"
              style="width: 500px"
            >
            </el-input>

          </div>
        </div>

        <br /><br />
        <div
          style="display: flex; justify-content: space-evenly; margin-top: 20px"
        >
          <!-- <el-button
            class="btn-submit"
            @click="pdbSubmit()"
            style="font-size: 22px; width: 120px; border-radius: 10px"
            >Submit</el-button
          > -->
          <span class="protein-info btn-info" @click="pdbSubmit()">
            <a style="padding: 6px 9px; font-size: 24px" hreflang="en"
              >Submit</a
            >
          </span>
        </div>
      </div>
    </div-unit>

    <div v-if="pageName!='HomeView'"><DownloadPage></DownloadPage></div>
  </div>
</template>
    
    <script>
import DivUnit from "@/components/DivUnit.vue";
import FileUpload from "@/components/new/file-upload.vue";
import DownloadPage from "@/views/DownloadPageSoft.vue";
import api from "@/api/index";
import pathUrl from "@/api/path";
export default {
  // name: "AdvancedAnalysis",
  data() {
    return {
      upload_url: pathUrl.baseUrl + "/the_biomarker/uploadSturcture",
      upload_str1: "",
      upload_str2: "",
      file_name1: "",
      file_name2: "",
      selected_chains1: [],
      selected_chains2: [],
      describe_structure1: "",
      describe_structure2: "",
      mission_id: "",

      alignments_options: {
        "Automatically select": "auto",
        "US alignment": "US",
        "SW alignment": "SW",
      },
      alignment_selected: "auto",
      email:"",
    };
  },
  props: {
    pageName: {
      type: String,
      required: true, default: 'DefaultPage',
    },
  },
  components: {
    DivUnit,DownloadPage,
    FileUpload,
  },

  methods: {
    uploadSuccess(response, index) {
      console.log(response);
      if (index === 1) {
        this.upload_str1 = response.random_str;
        this.file_name1 = response.file_name;
      } else if (index === 2) {
        this.upload_str2 = response.random_str;
        this.file_name2 = response.file_name;
      }
    },
    handleRemove(index) {
      if (index === 1) {
        this.upload_str1 = "";
        this.file_name1 = "";
      } else if (index === 2) {
        this.upload_str2 = "";
        this.file_name2 = "";
      }
    },
    uploadSelected(selected_chains, index) {
      if (index === 1) {
        this.selected_chains1 = selected_chains;
      } else if (index === 2) {
        this.selected_chains2 = selected_chains;
      }
    },
    uploadDescribed(newValue, index) {
      console.log(newValue, index);
      if (index === 1) {
        this.describe_structure1 = newValue;
      } else if (index === 2) {
        this.describe_structure2 = newValue;
      }
    },

    pdbSubmit() {
      if (
        !this.upload_str1 ||
        !this.upload_str2 ||
        this.selected_chains1.length === 0 ||
        this.selected_chains2.length === 0
      ) {
        this.$alert(
          "Please upload a pair of protein structure files and select the protein chains for assessment.",
          "Error",
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "Close",
          }
        );
        return; // Early return to stop further execution
      }
      const mission_id = String(Date.now());
      const post_data = {
        mission_id,
        upload_str1: this.upload_str1,
        upload_str2: this.upload_str2,
        selected_chains1: this.selected_chains1,
        selected_chains2: this.selected_chains2,
        file_name1: this.file_name1,
        file_name2: this.file_name2,
        describe_structure1: this.describe_structure1,
        describe_structure2: this.describe_structure2,
        alignment_selected: this.alignment_selected,
        email: this.email,
      };

      api.submitMissionNew(post_data).then((res) => {
        console.log(res);
      });
      this.$router.push("/assessment-result?id=" + mission_id);
    },
  },

  beforeMount() {},
  mounted() {},
  watch: {},
};
</script>
<style lang="less" scoped>
@color-theme: #e70;
@bg-theme: #fff;
@color-theme-hover: #409eff94;

.input_example {
  color: #409eff;
}

/deep/.el-button {
  font-size: 22px !important;
  height: 50px;
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  border-bottom-right-radius: 10px;
  border-top-right-radius: 10px;
  border: 2px;
  background: @color-theme;
}

/deep/.upload-btn {
  font-size: 18px !important;
  border-radius: 4px;
  height: 40px;
  margin-top: 20px;
}
/deep/.div-title {
  background: @color-theme;
}
/deep/.div-content {
  border-top: 0;
}
/deep/.div-unit {
  border: 3px solid @color-theme;
  border-color: @color-theme;
  background-color: @bg-theme;
}
</style>
    